import { appName } from "../config";
import api from "../config/api";
import { errorHandler } from "../config/api";

export const employeeLogin = async (username, password) => {
  try {
    const response = await api.post("/employee/login/", {
      username,
      password,
    });

    if (response?.status === 200 && response?.data?.data) {
      const userData = response.data.data;

      if (!userData) {
        console.error("userData is undefined or null");
        return {
          success: false,
          message: "Invalid user data",
        };
      }

      const serializedData = JSON.stringify(userData);

      localStorage.setItem(appName, serializedData);

      return {
        success: true,
        data: userData,
      };
    }

    const errorMessage = response.data.message || "Login failed";

    return {
      success: false,
      message: errorMessage,
    };
  } catch (error) {
    const errorMessage = errorHandler(
      error,
      "Something went wrong during login"
    );

    return {
      success: false,
      message: errorMessage,
    };
  }
};

export const logoutEmployee=() => {
    localStorage.removeItem(appName);
    console.log("Employee LoggedOut");
    
}